import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadoFranquiaChatRoutingModule } from './chamado-franquia-chat-routing.module';
import { ChamadoFranquiaChatComponent } from './chamado-franquia-chat.component';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RatingModule } from 'primeng/rating';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FormsModule } from '@angular/forms';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';


@NgModule({
  declarations: [
    ChamadoFranquiaChatComponent
  ],
  imports: [
    CommonModule,
    ChamadoFranquiaChatRoutingModule,
    FormsModule,
    DialogModule,
    ProgressSpinnerModule,
    ButtonModule,
    InputTextModule,
    RatingModule,
    OverlayPanelModule,
    FormatPipeModule,
    TooltipModule,
    MessagesModule,
    DividerModule
  ]
})
export class ChamadoFranquiaChatModule { }
